/**
 * FeedbackSidebarContext - Feedback sidebar state management
 */

import { createContext, ReactNode, useCallback, useContext, useMemo, useState } from 'react';

interface IFeedbackSidebarContextProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  toggle: () => void;
}

const FeedbackSidebarContext = createContext<IFeedbackSidebarContextProps | undefined>(undefined);

export function FeedbackSidebarProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

  const value = useMemo(() => ({ isOpen, setIsOpen, toggle }), [isOpen, toggle]);

  return (
    <FeedbackSidebarContext.Provider value={value}>{children}</FeedbackSidebarContext.Provider>
  );
}

export function useFeedbackSidebar(): IFeedbackSidebarContextProps {
  const context = useContext(FeedbackSidebarContext);
  if (context === undefined) {
    throw new Error('useFeedbackSidebar must be used within FeedbackSidebarProvider');
  }
  return context;
}
